import api from './api';
import dayjs from 'dayjs'

export const accountApi = api.injectEndpoints({
    endpoints: builder => ({
        getAppVersion: builder.query({
            query: () => ({
                url: '/app-version',
                method: 'get',
            }),
        }),
        finalizeAccount: builder.mutation({
            query: () => ({ url: '/account/finalise', method: 'post' }),
        }),
        activateAccount: builder.mutation({
            query: ({ activationCode, dob }) => ({
                url: `/account/activate`,
                method: 'post',
                data: { code: activationCode, dob: dayjs(dob).format('YYYY-MM-DD') },
            }),
        }),
    }),
});

export const {
    useFinalizeAccountMutation,
    useActivateAccountMutation,
    useGetAppVersionQuery,
} = accountApi;
